import { onDocumentReady } from "@story/story_assets";

onDocumentReady(function() {
	function pad(num, size) {
		num = num.toString();
		while (num.length < size) num = "0" + num;
		return num;
	}

	for (let timer of document.querySelectorAll("[data-timer]")) {
		const str = timer.getAttribute("data-timer");
		const dateTo = Date.parse(str);

		setInterval(function() {
			const currentDate = new Date();

			let remaining = null;
			if (currentDate <= dateTo) {
				let interval = (dateTo - currentDate) / 1000.0;
				let days = Math.floor(interval / 86400);
				let hours = Math.floor(interval % 86400 / 3600);
				let minutes = Math.floor(interval % 3600 / 60);
				let seconds = Math.floor(interval % 3600 % 60);

				remaining = "";
				if (0 < days) {
					remaining += days + "<span class='countdown-unit'>d</span>&nbsp;" + pad(hours, 2) + "<span class='countdown-unit'>h</span>&nbsp;"
				}
				else {
					remaining += hours + "<span class='countdown-unit'>h</span>&nbsp;";
				}
				remaining += pad(minutes, 2) + "<span class='countdown-unit'>m</span>&nbsp;" + pad(seconds, 2) + "<span class='countdown-unit'>s</span>";
			}
			else {
				remaining = "Čas vypršel!";
			}

			timer.innerHTML = remaining;
		}, 1000);
	}
});